export default __webpack_public_path__ + "static/media/withdrawal-bnb-cbd.5326277f.svg";